import React, { useState, useRef, useEffect } from 'react'

export default function FlipPopover({ canvas, selectedObject, onChange }) {
  const [open, setOpen] = useState(false)
  const popoverRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) setOpen(false)
    }
    const handleEscape = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [open])

  useEffect(() => { setOpen(false) }, [selectedObject])

  const flip = (axis) => {
    if (!selectedObject || !canvas) return
    const prop = axis === 'x' ? 'flipX' : 'flipY'
    canvas.fire('before:transform', { transform: { target: selectedObject } })
    selectedObject.set(prop, !selectedObject[prop])
    selectedObject.setCoords()
    canvas.fire('object:modified', { target: selectedObject })
    canvas.requestRenderAll()
    onChange?.()
    setOpen(false)
  }

  return (
    <div className="selection-toolbar__popover-anchor" ref={popoverRef}>
      <button
        className={`selection-toolbar__btn${open ? ' selection-toolbar__btn--active' : ''}`}
        onClick={() => setOpen(!open)}
        title="Flip"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 3H5a2 2 0 00-2 2v14c0 1.1.9 2 2 2h3" />
          <path d="M16 3h3a2 2 0 012 2v14a2 2 0 01-2 2h-3" />
          <line x1="12" y1="20" x2="12" y2="4" strokeDasharray="2 2" />
        </svg>
        Flip
      </button>

      {open && (
        <div className="selection-toolbar__popover">
          <button className="selection-toolbar__popover-btn" onClick={() => flip('x')}>Flip Horizontal</button>
          <button className="selection-toolbar__popover-btn" onClick={() => flip('y')}>Flip Vertical</button>
        </div>
      )}
    </div>
  )
}
